import { FinancialAccount } from "@common/types/financialAccount";
import { Switch } from "@design-system/Switch/Switch";
import { Tooltip } from "@design-system/Tooltip/Tooltip";
import { useContinuousReconciliationToggle } from "@hooks/useContinuousReconciliationToggle";

interface Props {
    financialAccount: FinancialAccount;
}

export const AccountContinuousReconciliation: React.FC<Props> = ({
    financialAccount,
}) => {
    const { isEnabled, disabledReason, setEnabled, isPending } =
        useContinuousReconciliationToggle(financialAccount);

    return (
        <Tooltip content={disabledReason}>
            <Switch
                checked={isEnabled}
                disabled={!!disabledReason}
                loading={isPending}
                onCheckedChange={setEnabled}
            />
        </Tooltip>
    );
};
